import * as messageService from "../../services/message.service";
import * as fuelTypeService from '../../services/fuelType.service';


const state = {
    fuelTypeAll:[],
    fuelTypeAllActive:[],
};

const getters = {
    gettFuelTypeAll:state => (state.fuelTypeAll),
    gettFuelTypeAllActive:state => (state.fuelTypeAllActive),
};

const actions = {
    async fetchFuelTypeAll({ commit } ){
        try {
            const response = await fuelTypeService.all();
            commit('setFuelTypeAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchFuelTypeAllActive({ commit } ){
        try {
            const response = await fuelTypeService.allActive();
            commit('setFuelTypeAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setFuelTypeAll:(state, res) => (
        state.fuelTypeAll =  res
    ),
    setFuelTypeAllActive:(state, res) => (
        state.fuelTypeAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}